import { CcfBox } from '@nice-ccf/ui-controls';
import { useSelector } from 'react-redux';
import { selectAcdLeftNavExpanded } from '../global.app.slice';
import CcfAcdDashboard from './ccf-acd-dashboard/ccf-acd-dashboard';
import CcfAcdLeftNav from './ccf-acd-left-nav/ccf-acd-left-nav';
import styles from './ccf-acd.module.scss';
import CcfAcdHeader from '../ccf-acd-header/ccf-acd-header';

/* eslint-disable-next-line */
export interface CcfAcdProps {}

/**
 *
 * @param props - CcfAcdProps
 * @returns
 * @example
 */
export function CcfAcd(props: CcfAcdProps) {
  const expandedAcdNav = useSelector(selectAcdLeftNavExpanded);
  return (
    <CcfBox display={'flex'} flexDirection={'column'} width={'100%'}>
    <CcfAcdHeader/>
    
    <CcfBox className={styles.acdContainer}>
      <div
        className={styles.acdLeftContainer}
        style={{ width: expandedAcdNav ? '20%' : '5%' }}
      >
        <CcfAcdLeftNav />
      </div>
      <div
        className={styles.acdRightContainer}
        style={{ width: expandedAcdNav ? '80%' : '95%' }}
      >
        <CcfAcdDashboard />
      </div>
    </CcfBox>
    </CcfBox>
  );
}

export default CcfAcd;
